import React from 'react';
import PropTypes from 'prop-types';

import { publishAnnouncement, unpublishAnnouncement } from '../../../../services/lwadmin/announcement/announcement-service';
import { Link, RowContainer } from '../../shared/styles';
import { ActionColumn, NameColumn } from './styles';
import useAnnouncementModalStore from '../../../announcement/state-hook';

export default function Announcement({ announcement }) {
  const {
    id,
    name,
    published,
    publishable,
    previewable,
  } = announcement;

  const [isPublished, setIsPublished] = React.useState(published);

  const set = useAnnouncementModalStore(state => state.set);

  const publish = e => {
    e && e.preventDefault();

    publishAnnouncement(id).then(() => setIsPublished(true));
  };

  const unpublish = e => {
    e && e.preventDefault();

    unpublishAnnouncement(id).then(() => setIsPublished(false));
  };

  const preview = e => {
    e && e.preventDefault();

    set(state => {
      state.show = true;
      state.currentAnnouncement = announcement;
    });
  };

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <ActionColumn>
        <Link href={`/lwadmin/announcement/${id}/edit`}>Edit</Link>
        {previewable && (
          <>
            |
            <Link href="#" onClick={preview}>Preview</Link>
          </>
        )}
        {(isPublished || publishable) && (
          <>
            |
            {isPublished && <Link href="#" onClick={unpublish}>Unpublish</Link>}
            {!isPublished && publishable && <Link href="#" onClick={publish}>Publish</Link>}
          </>
        )}
      </ActionColumn>
    </RowContainer>
  );
}

Announcement.propTypes = {
  announcement: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    heroImageUrl: PropTypes.string,
    headline: PropTypes.string,
    copy: PropTypes.string,
    buttonCopy: PropTypes.string,
    buttonLink: PropTypes.string,
    published: PropTypes.bool,
    publishable: PropTypes.bool,
    previewable: PropTypes.bool,
  }).isRequired,
};
